import React from 'react';
import { Row, Col } from 'reactstrap';


const HeadLineComponent = (props) => {

    return (
        <div className="text-center title">
            <Row className="bold main-text d-block">
                <p dangerouslySetInnerHTML={{ __html: props.text }} />
            </Row>
        </div>
    )
}

export default HeadLineComponent;
